import type React from "react";
import styles from "./StatusRadio.module.scss";

interface StatusRadioProps {
	name: string;
	value: string;
	label: string;
	checked?: boolean;
	onChange: (value: string) => void;
	variant?: "progress" | "completed";
}

const StatusRadio: React.FC<StatusRadioProps> = ({ name, value, label, checked = false, onChange, variant = "progress" }) => {
	const handleChange = () => {
		onChange(value);
	};

	const containerClasses = [
		styles.radioContainer,
		checked && styles.checked,
		checked && variant === "progress" && styles.progress,
		checked && variant === "completed" && styles.completed,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<label className={containerClasses}>
			<input type="radio" name={name} value={value} checked={checked} onChange={handleChange} className={styles.hiddenInput} />
			<div className={styles.radioButton}>
				<svg className={styles.checkmark} viewBox="0 0 24 24" fill="none">
					<path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</div>
			<span className={styles.label}>{label}</span>
		</label>
	);
};

export default StatusRadio;
